import PropTypes from "prop-types";

import { dispatch } from "../../../../../state/store";
import { setDeviceGroupsRefresh } from "../../../../../state/ducks";

import { strCode } from "../../../../../consts";
import { useGroupsData } from "../../../../../hooks";
import { notificationService, t } from "../../../../../services";

import { WrapperContainer } from "../../../../../components";
import GroupsTable from "../../../../Groups/GroupsTable";

export const DeviceGroups = ({
  groups,
  deviceGroupsLoading,
  groupChangesLoading,
  onCreateDeviceGroup,
  onUpdateDeviceGroup,
  onDeleteDeviceGroup
}) => {
  const { groupsData, editingGroup, setEditingGroup, onAddGroup, onEditCancel } =
    useGroupsData(groups);

  const handleEditSave = async (newGroupName, editingGroupName) => {
    if (
      newGroupName !== editingGroupName &&
      groupsData.some((group) => group.name === newGroupName)
    ) {
      notificationService.showError({
        title: t(strCode.GROUP_EDIT_ERROR),
        message: t(strCode.GROUP_ALREADY_EXIST_ERROR)
      });

      return false;
    }

    const group = groups.find((item) => item.name === editingGroupName);
    if (group) {
      await onUpdateDeviceGroup(group.id, newGroupName);
    } else {
      await onCreateDeviceGroup([newGroupName]);
    }

    setEditingGroup(null);
    dispatch(setDeviceGroupsRefresh(true));
  };

  const handleDelete = async (groupName) => {
    const group = groups.find((item) => item.name === groupName);

    if (group) {
      await onDeleteDeviceGroup(group.id);
    }

    dispatch(setDeviceGroupsRefresh(true));
  };

  return (
    <WrapperContainer>
      <GroupsTable
        groups={groupsData}
        editingGroup={editingGroup}
        loading={deviceGroupsLoading}
        loadingChanges={groupChangesLoading}
        setEditingGroup={setEditingGroup}
        onAdd={onAddGroup}
        onEditSave={handleEditSave}
        onEditCancel={onEditCancel}
        onDelete={handleDelete}
      />
    </WrapperContainer>
  );
};

DeviceGroups.propTypes = {
  groups: PropTypes.arrayOf(PropTypes.shape({ name: PropTypes.string.isRequired })).isRequired,
  deviceGroupsLoading: PropTypes.bool.isRequired,
  groupChangesLoading: PropTypes.bool.isRequired,
  onCreateDeviceGroup: PropTypes.func.isRequired,
  onUpdateDeviceGroup: PropTypes.func.isRequired,
  onDeleteDeviceGroup: PropTypes.func.isRequired
};
